import React, { type ComponentProps } from 'react';
import T from '@matejmazur/react-katex';

import useMetadata from 'src/util/hooks/useMetadata';

import cn from 'clsx';
import 'katex/dist/katex.min.css';
import * as css from './Tex.module.scss';

export type TeXProps = ComponentProps<typeof T>;
export default function Tex(props: TeXProps) {
    const { interiorTheme } = useMetadata();
    const themeClassname = `theme-${interiorTheme}`;

    if (props.block) {
        return (
            <div className={cn(css.block, themeClassname)}>
                <T {...props} block className={css.content} as="div" />
            </div>
        );
    }
    return <T {...props} className={cn(css.inline, themeClassname)} as="span" />;
}
